/**
 * Web Serial `requestPort({ filters })` only lists USB devices whose **USB Vendor ID**
 * (and optional Product ID) match. Bluetooth SPP, built‑in `/dev/cu.Bluetooth-*`, and many
 * non-USB “virtual” serial paths are then hidden from the browser picker.
 *
 * Add your company’s exact `usbVendorId` (and optional `usbProductId`) here if a device
 * does not appear — see Chrome DevTools → chrome://device-log or macOS System Information.
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Serial/requestPort
 */
export const COMPANY_USB_SERIAL_FILTERS: SerialPortFilter[] = [
  { usbVendorId: 0x303a }, // Espressif (ESP32-S2/S3 USB-CDC / USB-JTAG-Serial)
  { usbVendorId: 0x10c4 }, // Silicon Labs CP210x
  { usbVendorId: 0x1a86 }, // WCH CH340 / CH341 / CH9102 (e.g. cu.wchusbserial*)
  { usbVendorId: 0x0403 }, // FTDI
  { usbVendorId: 0x067b }, // Prolific PL2303
  { usbVendorId: 0x2341 }, // Arduino (some boards)
  { usbVendorId: 0x2e8a }, // Raspberry Pi Pico
];

/** Options passed to `navigator.serial.requestPort` / polyfill for LONGER tooling. */
export const COMPANY_SERIAL_REQUEST_OPTIONS: SerialPortRequestOptions = {
  filters: COMPANY_USB_SERIAL_FILTERS,
};
